import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AnalyticsRoute } from '@chr/online-shared-ui-analytics';
import { LinkService } from '@chr/online-shared-microsite-core';
import { Home } from './areas/home/Home';

export const AppRoutes = () => {
  const redirectToPageNotFound = (): React.ReactElement => {
    LinkService.getLinks().then(() => {
      if (LinkService.PAGE_NOT_FOUND) {
        window.location.assign(LinkService.PAGE_NOT_FOUND);
      }
    });

    return <div data-testid="page-not-found" />;
  };

  return (
    <Switch>
      <AnalyticsRoute
        exact={true}
        path="/:bookingNumber"
        component={Home}
        pageName="2.0 | Booking Details"
      />
      <Route component={redirectToPageNotFound} />
    </Switch>
  );
};
